@if (show) {
  <div class="toast" [class]="'toast ' + type" role="alert">
    <ng-content></ng-content>
  </div>
}
